import { Button } from '../../ui/Button';
import styles from './HomepageHero.module.css';

export function HomepageHero() {
  return (
    <section className={styles.hero} aria-label="Homepage hero">
      <div className={styles.inner}>
        <div className={styles.content}>
          {/* <div className={styles.eyebrow}>
            <span className={styles.eyebrowDot} aria-hidden="true" />
            Enterprise Data Intelligence
          </div> */}

          <h1 className={styles.headline}>
            Unify Your Data.{' '}
            <span className={styles.accent}>Accelerate</span>{' '}
            Your AI.
          </h1>

          <p className={styles.subline}>
            NAATS transforms fragmented enterprise data into governed, intelligence-ready platforms
            - delivering 50–90% reliability improvements and 5× operational efficiency gains across
            Financial, Healthcare, Pharmaceutical, and Petroleum sectors.
          </p>

          <div className={styles.actions}>
            <Button to="/contact" variant="primary" size="lg">
              Request a Demo
            </Button>
            <Button to="/platform" variant="outline-light" size="lg">
              Explore the Platform
            </Button>
          </div>

          {/* <div className={styles.trustLine}>
            <span>Cloud-agnostic</span>
            <span className={styles.trustDot} aria-hidden="true" />
            <span>Enterprise-grade governance</span>
            <span className={styles.trustDot} aria-hidden="true" />
            <span>Regulated industries</span>
          </div> */}
        </div>

      </div>
    </section>
  );
}
